export function contactModal() {
  const $container = $('aside.contact .contact__window')
  $('[href="#contact"]').click(function(e){
    e.preventDefault()
    $('body').addClass("open-contact")
    setTimeout(function(){
      $('aside.contact .focus :input:first').focus()
    }, 600)
    /*
    const $iframe = $container.find('iframe')
    if(!$iframe.length) {
      $container.append('<iframe onload="this.parentElement.classList.add(\'' + 'contact__window--loaded' + '\')" src="' + $container.attr("data-iframe") + '"></iframe>');
    }*/
  })
  const $closeButton = $container.find('a')
  $closeButton.click(function(e){
    e.preventDefault()
    $('body').removeClass("open-contact")
  })
  $('aside.contact').click(function(e){
    if(e.target == e.currentTarget) {
      e.preventDefault();
      $('body').removeClass('open-contact')
    }
  })
}

function focus() {
  $('body').on('focus', 'aside.contact form :input', function(){
    $('aside.contact .intro').removeClass('current');
    $('label.focus').removeClass('focus');
    const $label = $(this).closest('label');
    $label.addClass('focus')
  })
}

function file() {
  $('input[type=file]').each(function(){
    $('<span class="toggle-file">Seleziona un file</span>').insertAfter($(this));
    $(this).change(function(e){
      console.log(e)
      const fileName = e.target.value.split('\\').pop()
      $(this).nextAll('span.toggle-file').text(fileName)
    })
  })
  $('aside.contact form').each(function(){
    $(this).append('<a class="prev-step" href="#"></a>')
  })
  $('body').on('click', 'aside.contact .prev-step', function(e){
    e.preventDefault()
    const $input = $('aside.contact label.focus :input')
    move($input, false)
  })
}

function submit() {
  $('body').on('click', '.form-navigation a.cta', function(e){
    e.preventDefault()
    const $input = $(this).closest('label').find(':input')
    if($input.length) { move($input) }
  })
  const pressenter = $('.contact__steps').attr('data-pressenter')
  const submit = $('.contact__steps').attr('data-submit')
  $('<div class="form-navigation form-navigation--submit"><a href="#" class="cta">'+submit+'</a> <span>'+pressenter+'</span></div>')
    .insertAfter($('aside.contact form label:last-of-type :input'));
}

function keyboard() {
  const nextbutton = $('.contact__steps').attr('data-nextfield')
  const pressenter = $('.contact__steps').attr('data-pressenter')
  const presstab = $('.contact__steps').attr('data-presstab')
  $('aside.contact form :input').on('keydown', function(e) {
    const $this = $(this)
    const validprev = (!$this.val()) || $this.is(':checkbox') || $this.is(':radio') ? true : false
    if(validprev && (e.keyCode == 8)) {
      e.preventDefault();
      move($this, false)
    } else if((e.keyCode == 13 && !$(this).is('textarea')) || e.which == 9 ) {
      e.preventDefault();
      move($this);
    }
  }).on('input', function(){
    const $this = $(this)
    const $formnavigation = $this.nextAll('.form-navigation');
    const required = $this.is('[aria-required]')
    if($this.val() || !required) {
      $('span.validation').remove()
      if(!$formnavigation.length) {
        $('<div class="form-navigation"><a href="#" class="cta">'+nextbutton+'</a> <span>'+ ($(this).is('textarea') ? presstab : pressenter) +'</span></div>').insertAfter($this)
      } else {
        $formnavigation.show()
      }
    } else {
      $formnavigation.hide()
    }
  })
  $('aside.contact .outro :input').on('keydown', function(e) {
    if(e.keyCode == 13) {
      e.preventDefault();
      $('.outro .close-sidebar').click();
    }
  })
}

function move($element, next = true) {
  const $thislabel = $element.closest('label');
  const $newlabel = next ? $thislabel.next('label') : $thislabel.prev('label');
  let move = $newlabel.length;
  let valid = true;
  if(next){
    $thislabel.addClass('back');
    valid = validate($element);
  } else {
    $thislabel.removeClass('back');
  }
  if(move) {
    if(valid) { $newlabel.find(':input').first().focus().trigger('input'); }
  } else {
    if(next) {
      $('aside.contact .wpcf7-submit').trigger('click');
      $('.form-navigation--submit').addClass('loading')
    } else {
    }
  }
}

function validate($element) {
  const value = $element.val()
  let valid = true;
  let message = 'Questo campo è obbligatorio per proseguire';
  if($element.is('[aria-required]') || value){
    if($element.is('[type=email]')) {
      if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        valid = true;
      } else {
        message = 'La mail inserita non è corretta';
        valid = false;
      }
    } else if(!value) {
      valid = false;
    }
  }
  if(!valid) {
    $element.nextAll('.form-navigation').hide();
    $element.nextAll('.validation').remove();
    $('<span class="validation">' + message + '</span>').insertAfter($element)
  }
  return valid;
}

function cf7(){
  $(document).on('wpcf7invalid wpcf7spam', function() {
    $('.form-navigation--submit.loading').removeClass('loading')
  })
  $(document).on('wpcf7submit', function() {
  })
  $(document).on('wpcf7mailsent', function() {
    $('label.focus').removeClass('focus');
    $('aside.contact .outro').addClass('current');
    $('aside.contact .outro').find(':input').focus();
    $('.form-navigation--submit.loading').removeClass('loading')
  })
  $(document).on('wpcf7mailfailed', function() {
    $('.form-navigation--submit.loading').removeClass('loading')
  })
}

export function contactInit() {
  focus();
  keyboard();
  file();
  submit();
  cf7();
}
